import { useToast } from '@components/index'
import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { BaseParams } from 'types/utils'

interface UploadAttachmentInput {
  category: 'OTHER' | 'AMENDMENT'
  files: File[]
}

export function useUploadContractAttachment() {
  const queryClient = useQueryClient()
  const toast = useToast()
  const { t } = useTranslation('flat')

  const uploadAttachment = async ({
    id,
    body,
    params
  }: BaseParams<UploadAttachmentInput, 'POST', { type: 'flat' | 'offer' }>) => {
    const formData = new FormData()
    body?.files.forEach((file) => formData.append('attachments', file))
    if (body?.category) formData.append('category', body.category)

    const response = await apiClient.post(
      `${SNA_PREFIX}contracts/${id}/attachments`,
      formData,
      {
        params,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    )
    return response.data
  }

  return useMutation({
    mutationFn: uploadAttachment,
    onSuccess: () => {
      // Invalidate any queries that include 'contracts' in their key
      queryClient.invalidateQueries({ queryKey: ['contracts'] })
      queryClient.invalidateQueries({ queryKey: ['offers-detail'] })
      toast.success({ message: t('toast.attachmentUploaded') })
    }
  })
}
